import { Binder } from '@ribajs/core'
import { ShopifyCartService } from '../services/index.js'
import { ShopifyCartObject } from '../types/index.js'

/**
 * Sets the shopify items count
 */
export class ShopifyCartCountBinder extends Binder<void, HTMLElement> {
  static key = 'shopify-cart-count'

  private onCartRequestComplete(cart: ShopifyCartObject) {
    if (cart) {
      this.setCount(cart.item_count)
    }
  }

  private onCartRequestChanged(cart: ShopifyCartObject) {
    this.setCount(cart.item_count)
  }

  private setCount(count: number) {
    if (!count) {
      this.el.textContent = ''
      if (this.el.parentElement) {
        this.el.parentElement.style.display = 'none'
      }
      return
    }
    if (this.el.parentElement) {
      this.el.parentElement.style.display = ''
    }
    this.el.textContent = String(count)
  }

  routine() {
    //
  }

  bind() {
    ShopifyCartService.events.on(
      'ShopifyCart:request:complete',
      this.onCartRequestComplete,
      this,
    )
    ShopifyCartService.events.on(
      'ShopifyCart:request:changed',
      this.onCartRequestChanged,
      this,
    )
  }

  unbind() {
    ShopifyCartService.events.off(
      'ShopifyCart:request:complete',
      this.onCartRequestComplete,
      this,
    )
    ShopifyCartService.events.off(
      'ShopifyCart:request:changed',
      this.onCartRequestChanged,
      this,
    )
  }
}
